'use strict';
import {Observable} from 'rxjs/Observable';
import {ajax} from 'rxjs/observable/dom/ajax';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {API_URL} from '../../config/constants';
import {getOnline$} from '../../core-utilities/network';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {firebaseAuthSuccess, requestLogout} from '../../auth/actions';
import {getApiToken} from '../../auth/reducers';
import {pingServer, pingServerError, pingServerSuccess} from '../actions';
import {logger} from './logger';


export class PingServerEpics {

  constructor(logger) {

    this._options = {
      getToken: getApiToken,
    };

    /** @type {AjaxCreationMethod} */
    this.ajax = ajax;
    this.online$ = getOnline$();

    this.logger = logger;
    this.PING_INTERVAL = 5 * 60 * 1000;
    this.requestTimeout = 25000;
    this.url = `${API_URL}/api/server-status`;

    this.onPingServer = this.onPingServer.bind(this);
    this.sendPingServer = this.sendPingServer.bind(this);

    this.epics = [
      this.onPingServer,
      this.sendPingServer,
    ];
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @return {Observable<ReduxAction>}
   */
  onPingServer(action$) {
    return action$.ofType(pingServer.TYPE)
      .switchMap(() =>
        this.ajax(this.getRequestConfig())
          .map(ajaxResponse => ajaxResponse.status === 200 ? pingServerSuccess() : pingServerError())
          .catch(err => Observable.of(pingServerError()))
      )
      .catch(epicErrorHandler(this.logger, 'onPingServer'));
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @return {Observable<ReduxAction>}
   */
  sendPingServer(action$) {
    return action$.ofType(firebaseAuthSuccess.TYPE)
      .switchMap(action => !action.payload.userId ? Observable.empty() :
        this.online$
          .switchMap(isOnline => !isOnline
            ? Observable.of(pingServerError())
            : Observable
              .merge(
                Observable.of(pingServer()),
                Observable
                  .interval(this.PING_INTERVAL)
                  .map(() => pingServer()),
              )
          )
          .takeUntil(action$.ofType(requestLogout.TYPE))
      )
      .catch(epicErrorHandler(this.logger, 'sendPingServer'));
  }

  /**
   * @return {AjaxRequest}
   */
  getRequestConfig() {
    return {
      crossDomain: true,
      method: 'GET',
      responseType: 'json',
      timeout: this.requestTimeout,
      url: this.url,
    };
  }
}

export const pingServerEpics = new PingServerEpics(logger);
export const epics = pingServerEpics.epics;



// WEBPACK FOOTER //
// ./src/js/settings/epics/onPingServer.js